import { PERIODS } from './format';
import { cn } from '@/utils/cn';

/**
 * The window every report on a page shares.
 *
 * One control for the whole screen rather than one per card: two panels
 * showing different periods side by side is a misreading waiting to happen.
 */
export function PeriodPicker({ value, onChange, label = 'Period' }) {
  return (
    // Drawn like SegmentedTabs, so every switch in the console looks alike.
    <div
      className="bg-surface ring-line inline-flex flex-wrap items-center gap-0.5 rounded-lg p-0.5 ring-1 ring-inset"
      role="group"
      aria-label={label}
    >
      {PERIODS.map((period) => (
        <button
          key={period.days}
          type="button"
          aria-pressed={value === period.days}
          onClick={() => onChange(period.days)}
          className={cn(
            'inline-flex h-7 items-center rounded-md px-2.5 text-[12px] font-medium whitespace-nowrap transition',
            value === period.days
              ? 'bg-brand-600 shadow-brand-600/20 text-white shadow-sm'
              : 'text-ink-muted hover:bg-brand-50 hover:text-ink',
          )}
        >
          {period.label}
        </button>
      ))}
    </div>
  );
}
